import { Injectable } from '@angular/core';
import { companyStateInitialState, CompanyStateProps, companyStateStore } from './company-state.store';
import { select } from '@ngneat/elf';
import { BaseStoreRepository } from '../base-store.repository';

@Injectable({
  providedIn: 'root',
})
export class CompanyRepository extends BaseStoreRepository<CompanyStateProps> {
  constructor() {
    super(companyStateStore.pipe(select(state => state)), companyStateStore, companyStateInitialState);
  }
}
